exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-7e86a7f0]{\n    width: 200px;\n}\n", ""]);

// exports
